import Icon from '../components/Icon';
import PlaceImage from '../components/PlaceImage';
import React, { useState, useMemo, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Tours.css';

const WA = '919445879508';

/* ══════════════════════════════════════════════════════════════
   COMPLETE PACKAGE DATABASE — Maggi Cabs
   Tamil Nadu 40+ | Kerala 30+ | 100+ Tour Packages
   ══════════════════════════════════════════════════════════════ */

const ALL_PACKAGES = [

  /* ══════════════════════════════
     TAMIL NADU — HILL STATIONS
     ══════════════════════════════ */
  { id:1, state:'Tamil Nadu', cat:'Hill Stations', dest:'Kodaikanal', type:'Honeymoon', icon:'heart', tag:'Most Popular',
    title:'Kodaikanal Honeymoon Special',
    desc:"Romantic sunrise at Coaker's Walk, boat ride on the star-shaped Kodai Lake, misty Pine Forest walk and Silver Cascade waterfall.",
    includes:["Coaker's Walk Sunrise",'Kodai Lake Boating','Silver Cascade','Pine Forest','Pillar Rocks','Bear Shola Falls'],
    duration:'2 Days / 1 Night', vehicle:'4-Seater Car', highlight:'Flower decoration on request',
    img:'/images/destinations/kodaikanal.jpg' },

  { id:2, state:'Tamil Nadu', cat:'Hill Stations', dest:'Kodaikanal', type:'Family', icon:'users',
    title:'Kodaikanal Family Package',
    desc:"Kid-friendly Kodaikanal covering Bryant Park, Guna Cave, Silver Cascade and Kodai Lake with horse riding and boating.",
    includes:['Kodai Lake','Bryant Park','Silver Cascade','Fairy Falls','Guna Cave','Valley View'],
    duration:'Full Day', vehicle:'7-Seater SUV', highlight:'Child-friendly itinerary',
    img:'/images/destinations/kodaikanal.jpg' },

  { id:3, state:'Tamil Nadu', cat:'Hill Stations', dest:'Kodaikanal', type:'Group', icon:'users',
    title:'Kodaikanal Group Tour',
    desc:"Full-day group sightseeing covering all major viewpoints, waterfalls and the scenic Pine Forest.",
    includes:["Coaker's Walk",'Pillar Rocks','Guna Cave','Silver Cascade','Pine Forest','Kodai Lake',"Dolphin's Nose",'Bear Shola Falls'],
    duration:'Full Day', vehicle:'12 or 25 Seater', highlight:'8+ spots — group discount',
    img:'/images/destinations/kodaikanal.jpg' },

  { id:4, state:'Tamil Nadu', cat:'Hill Stations', dest:'Ooty', type:'Honeymoon', icon:'heart',
    title:'Ooty Honeymoon Package',
    desc:"Romance in the Nilgiris — Botanical Garden, Ooty Lake, Doddabetta Peak, Nilgiri toy train ride and rose gardens.",
    includes:['Ooty Botanical Garden','Doddabetta Peak','Nilgiri Toy Train Ride','Ooty Lake Boating','Rose Garden','Pykara Lake'],
    duration:'2 Days / 1 Night', vehicle:'4-Seater Car', highlight:'Toy train couple tickets',
    img:'/images/destinations/ooty.jpg' },

  { id:5, state:'Tamil Nadu', cat:'Hill Stations', dest:'Ooty', type:'Family', icon:'users',
    title:'Ooty Family Tour',
    desc:"The Queen of Hills for families — Botanical Garden, Wax World, Ooty Lake boating, Pykara waterfall and toy train.",
    includes:['Ooty Botanical Garden','Pykara Falls','Ooty Lake','Wax World Museum','Tea Factory','Thread Garden'],
    duration:'Full Day / 2 Days', vehicle:'7-Seater SUV', highlight:'Toy train experience',
    img:'/images/destinations/ooty.jpg' },

  { id:6, state:'Tamil Nadu', cat:'Hill Stations', dest:'Coonoor', type:'Sightseeing', icon:'leaf',
    title:'Coonoor Day Trip',
    desc:"The quieter, greener sibling of Ooty — Sim's Park, Dolphin's Nose viewpoint, Lamb's Rock and rolling tea estates.",
    includes:["Sim's Park","Lamb's Rock","Dolphin's Nose",'Tea Estate Walk','Droog Fort','High Field Tea Factory'],
    duration:'Full Day', vehicle:'4 or 7 Seater', highlight:'Less crowded than Ooty',
    img:'/images/destinations/coonoor.jpg' },

  { id:7, state:'Tamil Nadu', cat:'Hill Stations', dest:'Yercaud', type:'Sightseeing', icon:'mountain',
    title:'Yercaud Hill Station Tour',
    desc:"The Jewel of the South — Shevaroy Hills covered with coffee and spice plantations, Yercaud Lake and Anna Park.",
    includes:['Yercaud Lake','Anna Park','Pagoda Point','Servarayan Temple',"Lady's Seat",'Killiyur Falls'],
    duration:'Full Day', vehicle:'4 or 7 Seater', highlight:'Coffee estate tour included',
    img:'/images/destinations/yercaud.jpg' },

  { id:8, state:'Tamil Nadu', cat:'Hill Stations', dest:'Kotagiri', type:'Sightseeing', icon:'compass',
    title:'Kotagiri Tea Estate Tour',
    desc:"The oldest hill station in the Nilgiris — tea factory tours, Kodanad viewpoint, Catherine Falls and Rangaswamy Peak.",
    includes:['Kodanad Viewpoint','Catherine Falls','Rangaswamy Peak','Tea Factory Tour','Elk Falls','Village Walk'],
    duration:'Full Day', vehicle:'4 or 7 Seater', highlight:'Oldest Nilgiri hill station',
    img:'/images/destinations/kotagiri.jpg' },

  { id:9, state:'Tamil Nadu', cat:'Hill Stations', dest:'Valparai', type:'Nature', icon:'compass',
    title:'Valparai Wildlife & Tea Tour',
    desc:"A hidden gem in the Anamalai Hills — dense tea estates, elephants crossing roads and shola forests.",
    includes:['Monkey Falls','Balaji Temple','Grass Hills','Tea Estate Drive','Elephant Spotting','Sholayar Dam'],
    duration:'Full Day', vehicle:'4 or 7 Seater', highlight:'Wild elephant sightings on road',
    img:'/images/destinations/valparai.jpg' },

  { id:10, state:'Tamil Nadu', cat:'Hill Stations', dest:'Yelagiri', type:'Sightseeing', icon:'compass',
    title:'Yelagiri Hills Package',
    desc:"A peaceful hill station near Vellore — Punganur Lake, Swamimalai Hills and adventure sports in lush green surroundings.",
    includes:['Punganur Lake','Swamimalai Hill','Nilavoor Lake','Nature Walk','Boat Ride','Yelagiri Peak View'],
    duration:'Full Day', vehicle:'4 or 7 Seater', highlight:'Adventure sports available',
    img:'/images/destinations/yelagiri.jpg' },

  { id:11, state:'Tamil Nadu', cat:'Hill Stations', dest:'Kolli Hills', type:'Adventure', icon:'mountain',
    title:'Kolli Hills Adventure Tour',
    desc:"72 hairpin bends to the top! Arapaleeswarar Temple, Agaya Gangai waterfall and untouched tribal villages.",
    includes:['72 Hairpin Bends Drive','Arapaleeswarar Temple','Agaya Gangai Falls','Tribal Village Visit','Herbal Garden','Selur Arch Dam'],
    duration:'Full Day', vehicle:'4 or 7 Seater', highlight:'72 hairpin bend drive',
    img:'/images/destinations/kolli-hills.jpg' },

  /* ══════════════════════════════
     TAMIL NADU — TEMPLES / SPIRITUAL
     ══════════════════════════════ */
  { id:12, state:'Tamil Nadu', cat:'Temple & Spiritual', dest:'Madurai', type:'Pilgrimage', icon:'temple', tag:'Popular',
    title:'Madurai Meenakshi Temple Tour',
    desc:"City of Temples — the magnificent Meenakshi Amman Temple, Thirumalai Nayakkar Palace and vibrant bazaars.",
    includes:['Meenakshi Amman Temple','Thirumalai Nayakkar Palace','Koodal Azhagar Temple','Gandhi Memorial Museum','Teppakulam Lake','Jigarthanda Food Stop'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Night aarti darshan available',
    img:'/images/destinations/madurai.jpg' },

  { id:13, state:'Tamil Nadu', cat:'Temple & Spiritual', dest:'Rameswaram', type:'Pilgrimage', icon:'compass',
    title:'Rameswaram Sacred Pilgrimage',
    desc:"One of India's holiest shrines — Ramanathaswamy Temple with 1,212 corridor pillars and the sacred Agni Theertham.",
    includes:['Ramanathaswamy Temple','Agni Theertham Bath','Dhanushkodi','Pamban Bridge','22 Theertham Circuit','Ariyaman Beach'],
    duration:'2 Days / 1 Night', vehicle:'Any Vehicle', highlight:'22 holy theertham baths',
    img:'/images/destinations/rameswaram.jpg' },

  { id:14, state:'Tamil Nadu', cat:'Temple & Spiritual', dest:'Chidambaram', type:'Pilgrimage', icon:'temple',
    title:'Chidambaram Nataraja Temple Tour',
    desc:"The cosmic dance of Shiva — Thillai Nataraja Temple, one of the Pancha Bhuta Sthalams representing space (Akash).",
    includes:['Thillai Nataraja Temple','Shivaganga Tank','Periyanayaki Amman','Nritya Sabhai','Thiruvengadu Temple','Pichavaram Mangroves'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Pancha Bhuta Sthalams — Akash',
    img:'/images/destinations/chidambaram.jpg' },

  { id:15, state:'Tamil Nadu', cat:'Temple & Spiritual', dest:'Kanchipuram', type:'Pilgrimage', icon:'temple',
    title:'Kanchipuram Temple City Tour',
    desc:"City of Thousand Temples and Silk Sarees — Kailasanathar, Varadharaja Perumal and Ekambareswarar temples.",
    includes:['Kailasanathar Temple','Varadharaja Perumal Temple','Ekambareswarar Temple','Kamakshi Amman','Silk Weaving Visit','Vedanthangal Bird Sanctuary'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'1,000 temples — silk city',
    img:'/images/destinations/kanchipuram.jpg' },

  { id:16, state:'Tamil Nadu', cat:'Temple & Spiritual', dest:'Tiruchirappalli', type:'Pilgrimage', icon:'compass',
    title:'Trichy Rock Fort & Srirangam Tour',
    desc:"Rock Fort Temple towering 83m high + the world's largest functioning Hindu temple at Srirangam island.",
    includes:['Rock Fort Uchi Pillayar','Sri Ranganathaswamy Temple','Jambukeswarar Temple','Cauvery River','Lourdes Church','Anna Museum'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'World\'s largest temple complex',
    img:'/images/destinations/tiruchirappalli.jpg' },

  { id:17, state:'Tamil Nadu', cat:'Temple & Spiritual', dest:'Palani', type:'Pilgrimage', icon:'temple',
    title:'Palani Murugan Temple Tour',
    desc:"Arulmigu Dhandayuthapani Swamy atop Sivagiri Hill — one of the six abodes of Lord Murugan.",
    includes:['Palani Murugan Temple','Cable Car Ride','Theertham Bath','Panchamirtham Prasad','Thiruparamkunram Temple','Govindhasamy Temple'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Cable car to summit included',
    img:'/images/destinations/palani.jpg' },

  { id:18, state:'Tamil Nadu', cat:'Temple & Spiritual', dest:'Tiruvannamalai', type:'Pilgrimage', icon:'compass',
    title:'Tiruvannamalai Arunachala Tour',
    desc:"The sacred fire hill — Annamalaiyar Temple, girivalam path around Arunachala and Ramana Maharshi Ashram.",
    includes:['Annamalaiyar Temple','Arunachala Girivalam Path','Ramana Maharshi Ashram','Sri Seshadri Swamigal Ashram','Adi Annamalai Temple','Sunrise at Hill Top'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Sacred 14-km girivalam circuit',
    img:'/images/destinations/tiruvannamalai.jpg' },

  { id:19, state:'Tamil Nadu', cat:'Temple & Spiritual', dest:'Srirangam', type:'Pilgrimage', icon:'temple',
    title:'Srirangam + Thanjavur Combo',
    desc:"Two UNESCO-level temple towns — Sri Ranganathaswamy Temple (world's largest) + Brihadeeswarar Temple.",
    includes:['Sri Ranganathaswamy Temple','Brihadeeswarar Temple','Rock Fort','Saraswathi Mahal Library','Thanjavur Palace','Art Gallery'],
    duration:'Full Day / Overnight', vehicle:'Any Vehicle', highlight:'2 UNESCO sites in 1 day',
    img:'/images/destinations/srirangam.jpg' },

  /* ══════════════════════════════
     TAMIL NADU — HERITAGE / CULTURAL
     ══════════════════════════════ */
  { id:20, state:'Tamil Nadu', cat:'Heritage & Culture', dest:'Thanjavur', type:'Heritage', icon:'temple',
    title:'Thanjavur Chola Heritage Tour',
    desc:"The Chola capital — Brihadeeswarar Temple (UNESCO), Thanjavur Palace, Saraswathi Mahal Library and classical art galleries.",
    includes:['Brihadeeswarar Temple','Thanjavur Palace & Museum','Saraswathi Mahal Library','Art Gallery','Sangeetha Mahal','Schwartz Church'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'UNESCO World Heritage Temple',
    img:'/images/destinations/thanjavur.jpg' },

  { id:21, state:'Tamil Nadu', cat:'Heritage & Culture', dest:'Chettinad', type:'Heritage', icon:'compass',
    title:'Chettinad Heritage & Food Tour',
    desc:"Grand Nattukotai Chettiar mansions, antique collections and the world-famous Chettinad cuisine experience.",
    includes:['Chettinad Palace Visit','Kanadukathan Heritage Walk','Local Cuisine Experience','Antique Shops','Athangudi Tile Factory','Karaikudi Town'],
    duration:'Full Day', vehicle:'7 or 12 Seater', highlight:'Famous Chettinad lunch included',
    img:'/images/destinations/chettinad.jpg' },

  { id:22, state:'Tamil Nadu', cat:'Heritage & Culture', dest:'Mahabalipuram', type:'Heritage', icon:'mountain',
    title:'Mahabalipuram Shore Temple Tour',
    desc:"Pallava dynasty rock-cut temples and sculptures on the Bay of Bengal coast — UNESCO World Heritage Site.",
    includes:['Shore Temple','Five Rathas','Arjuna\'s Penance','Krishna\'s Butter Ball','Tiger Cave','Mahabalipuram Beach'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'UNESCO Pallava rock temples',
    img:'/images/destinations/mahabalipuram.jpg' },

  { id:23, state:'Tamil Nadu', cat:'Heritage & Culture', dest:'Gangaikonda Cholapuram', type:'Heritage', icon:'temple',
    title:'Gangaikonda Cholapuram Tour',
    desc:"The lost Chola capital — a lesser-known but magnificent Brihadeeswarar temple built by Rajendra Chola.",
    includes:['Gangaikonda Cholapuram Temple','Chola Museum','Kumbakonam Temple Circuit','Airavatesvara Temple Darasuram','Swamimalai Bronze Art','Cauvery River Ghat'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Forgotten Chola capital — less crowds',
    img:'/images/destinations/gangaikonda-cholapuram.jpg' },

  { id:24, state:'Tamil Nadu', cat:'Heritage & Culture', dest:'Darasuram', type:'Heritage', icon:'temple',
    title:'Darasuram Airavatesvara Tour',
    desc:"The third of the Great Living Chola Temples — Airavatesvara Temple at Darasuram with intricate stone carvings.",
    includes:['Airavatesvara Temple Darasuram','Kumbakonam Temples','Sarangapani Temple','Brahadeeswarar Thanjavur','Mahamaham Tank','Pottery Village'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'3rd UNESCO Great Chola Temple',
    img:'/images/destinations/darasuram.jpg' },

  /* ══════════════════════════════
     TAMIL NADU — BEACHES / COASTAL
     ══════════════════════════════ */
  { id:25, state:'Tamil Nadu', cat:'Beaches & Coastal', dest:'Kanyakumari', type:'Honeymoon', icon:'compass', tag:'Romantic',
    title:'Kanyakumari Honeymoon Tour',
    desc:"Where three seas meet at India's southern tip — sunrise/sunset views, Vivekananda Rock and pristine beaches.",
    includes:['Vivekananda Rock Memorial','Thiruvalluvar Statue','Kumari Amman Temple','Sunrise & Sunset Views','Padmanabhapuram Palace','Thirparappu Falls'],
    duration:'2 Days / 1 Night', vehicle:'4-Seater Car', highlight:'Sunrise boat to Vivekananda Rock',
    img:'/images/destinations/kanyakumari.jpg' },

  { id:26, state:'Tamil Nadu', cat:'Beaches & Coastal', dest:'Velankanni', type:'Pilgrimage', icon:'temple',
    title:'Velankanni Basilica Pilgrimage',
    desc:"Our Lady of Good Health Basilica — the Lourdes of the East on the Coromandel Coast.",
    includes:['Velankanni Basilica','Miraculous Medal Shrine','Museum of Miracles','Lighthouse Beach','Beach Darshan','Nagapattinam Temples'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Lourdes of the East',
    img:'/images/destinations/velankanni.jpg' },

  { id:27, state:'Tamil Nadu', cat:'Beaches & Coastal', dest:'Nagapattinam', type:'Heritage', icon:'compass',
    title:'Nagapattinam Coastal Heritage Tour',
    desc:"Historic port town with Dutch heritage, ancient temples and the serene Coromandel coast beaches.",
    includes:['Kayarohana Swami Temple','Sikkal Singaravelan Temple','Dutch Bungalow','Tsunami Memorial Park','Nagore Dargah','Velankanni Basilica'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Dutch colonial heritage',
    img:'/images/destinations/nagapattinam.jpg' },

  { id:28, state:'Tamil Nadu', cat:'Beaches & Coastal', dest:'Poompuhar', type:'Heritage', icon:'compass',
    title:'Poompuhar Ancient Port Tour',
    desc:"The ancient Chola port city of Kaveripattinam — Silappathikaram monument, beach and the mouth of River Kaveri.",
    includes:['Poompuhar Beach','Silappathikaram Art Gallery','Kaveri River Mouth','Ancient Port Site','Marine Museum','Tranquebar Dutch Fort'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Ancient Chola maritime history',
    img:'/images/destinations/poompuhar.jpg' },

  /* ══════════════════════════════
     TAMIL NADU — NATURE / WILDLIFE
     ══════════════════════════════ */
  { id:29, state:'Tamil Nadu', cat:'Nature & Wildlife', dest:'Mudumalai National Park', type:'Wildlife', icon:'compass',
    title:'Mudumalai Wildlife Safari',
    desc:"One of the finest wildlife corridors in South India — spot elephants, tigers, leopards and gaur in their natural habitat.",
    includes:['Jeep Safari (Forest Dept)','Elephant Camp Visit','Moyar River View','Ooty Combine Option','Bird Watching Trail','Theppakadu Elephant Camp'],
    duration:'Full Day', vehicle:'4 or 7 Seater', highlight:'Tiger Reserve — Big 5 spotted',
    img:'/images/destinations/mudumalai-national-park.jpg' },

  { id:30, state:'Tamil Nadu', cat:'Nature & Wildlife', dest:'Anamalai Tiger Reserve', type:'Wildlife', icon:'leaf',
    title:'Anamalai Tiger Reserve Tour',
    desc:"Indira Gandhi Wildlife Sanctuary — one of the richest biodiversity zones with elephants, lions and over 300 bird species.",
    includes:['Topslip Safari','Elephant Bathing Point','Amaravathi Dam','Sethumadai Village','Indira Gandhi Statue','Pollachi Coconut Farms'],
    duration:'Full Day', vehicle:'4 or 7 Seater', highlight:'Lion-tailed Macaque spotting',
    img:'/images/destinations/anamalai-tiger-reserve.jpg' },

  { id:31, state:'Tamil Nadu', cat:'Nature & Wildlife', dest:'Hogenakkal Falls', type:'Nature', icon:'compass',
    title:'Hogenakkal Falls Day Trip',
    desc:"The Niagara of India — spectacular Kaveri waterfalls with coracle boat rides through the gorge.",
    includes:['Hogenakkal Waterfall View','Coracle Boat Ride','Fish Massage (Optional)','Marikottayam Island','Bathing Ghat','Pennagaram Fort'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Coracle boat in gorge',
    img:'/images/destinations/hogenakkal-falls.jpg' },

  { id:32, state:'Tamil Nadu', cat:'Nature & Wildlife', dest:'Courtallam', type:'Nature', icon:'compass',
    title:'Courtallam Waterfalls Tour',
    desc:"The Spa of South India — 9 waterfalls with medicinal herbal properties. Perfect for summer cooling.",
    includes:['Main Falls','Five Falls','Old Courtallam Falls','Shenbagadevi Falls','Pechiamman Temple','Tenkasi Kasi Viswanathar Temple'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'9 medicinal waterfalls',
    img:'/images/destinations/courtallam.jpg' },

  /* ══════════════════════════════
     TAMIL NADU — OTHER DESTINATIONS
     ══════════════════════════════ */
  { id:33, state:'Tamil Nadu', cat:'Other Destinations', dest:'Dhanushkodi', type:'Heritage', icon:'compass',
    title:'Dhanushkodi Ghost Town Tour',
    desc:"The abandoned town at the tip of Pamban Island — destroyed by the 1964 cyclone, now a haunting and beautiful landscape.",
    includes:['Dhanushkodi Ghost Town','Arichal Munai Tip','Bay of Bengal & Indian Ocean Confluence','Old Church Ruins','Pamban Bridge View','Rameswaram Temple'],
    duration:'Full Day', vehicle:'4 or 7 Seater', highlight:'Land\'s end — two seas meet',
    img:'/images/destinations/dhanushkodi.jpg' },

  { id:34, state:'Tamil Nadu', cat:'Other Destinations', dest:'Kumbakonam', type:'Pilgrimage', icon:'temple',
    title:'Kumbakonam Temple Circuit',
    desc:"The Temple Town of Tamil Nadu — 12 major temples, Mahamaham sacred tank and classical Chola-era art.",
    includes:['Sarangapani Temple','Kumbheswarar Temple','Mahamaham Tank','Nageshwarar Temple','Adi Kumbeswarar Temple','Darasuram Airavatesvara'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'12 major temples in one town',
    img:'/images/destinations/kumbakonam.jpg' },

  { id:35, state:'Tamil Nadu', cat:'Other Destinations', dest:'Tirunelveli', type:'Sightseeing', icon:'leaf',
    title:'Tirunelveli & Courtallam Tour',
    desc:"Nellai's Nellaiappar Temple, the famous Iruttu Kadai Halwa and Courtallam waterfalls combo.",
    includes:['Nellaiappar Temple','Krishnapuram Palace','Courtallam Falls','Manimuthar Dam','Papanasam Dam','Iruttu Kadai Halwa'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Famous Tirunelveli Halwa tasting',
    img:'/images/destinations/tirunelveli.jpg' },

  { id:36, state:'Tamil Nadu', cat:'Other Destinations', dest:'Srivilliputhur', type:'Pilgrimage', icon:'temple',
    title:'Srivilliputhur Andal Temple Tour',
    desc:"Temple of Andal — the only temple whose gopuram features on the Tamil Nadu government emblem.",
    includes:['Andal Temple Srivilliputhur','Vadapatrasayi Temple','Rajapalayam Vijayarama Raja Temple','Sivakasi Fireworks Factory','Ayyanar Kovil','Sattur Fort'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Emblem of Tamil Nadu',
    img:'/images/destinations/srivilliputhur.jpg' },

  { id:37, state:'Tamil Nadu', cat:'Other Destinations', dest:'Ramanathapuram', type:'Heritage', icon:'compass',
    title:'Ramanathapuram Setupati Heritage',
    desc:"The kingdom of the Setupati kings — Ramnad Palace, Rameswaram proximity and the pearl fishing town of Tuticorin.",
    includes:['Ramnad Palace & Museum','Sethupathy Fort','Erwadi Dargah','Devipattinam Navagraha Beach','Pamban Bridge','Rameswaram'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Setupati palace & heritage',
    img:'/images/destinations/ramanathapuram.jpg' },

  { id:38, state:'Tamil Nadu', cat:'Other Destinations', dest:'Thoothukudi', type:'Coastal', icon:'compass',
    title:'Thoothukudi Pearl City Tour',
    desc:"The Pearl City — Hare Island, Threspuram Beach, Gulf of Mannar Marine National Park snorkelling.",
    includes:['Hare Island Beach','Our Lady of Snows Basilica','Gulf of Mannar Marine Park','Tiruchendur Murugan Temple','Kayalpatnam','Pearl Industry Visit'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Gulf of Mannar coral reefs',
    img:'/images/destinations/thoothukudi.jpg' },

  { id:39, state:'Tamil Nadu', cat:'Other Destinations', dest:'Sivakasi', type:'Industry', icon:'compass',
    title:'Sivakasi Fireworks Factory Tour',
    desc:"The Fireworks Capital of India — safe guided tour of fireworks and match factories, plus Kalidass Nagar.",
    includes:['Fireworks Factory Tour (Safe)','Match Factory Visit','Arulmigu Durga Devi Temple','Srivilliputhur Andal Temple','Rajapalayam Tour','Shopping for Crackers'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:"India's fireworks capital",
    img:'/images/destinations/sivakasi.jpg' },

  { id:75, state:'Tamil Nadu', cat:'Other Destinations', dest:'Salem', type:'Sightseeing', icon:'compass',
    title:'Salem City & Yercaud Hills Tour',
    desc:"Steel City of Tamil Nadu — Yercaud hill station nearby, Sugavaneswarar Temple, Kottai and beautiful rose garden.",
    includes:['Yercaud Hill Station','Sugavaneswarar Temple','Kottai (Salem Fort)','Mettur Dam','Kiliyur Falls','Rose Garden Yercaud'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Mettur Dam — largest in Tamil Nadu',
    img:'/images/destinations/salem.jpg' },

  { id:76, state:'Tamil Nadu', cat:'Other Destinations', dest:'Erode', type:'Heritage', icon:'compass',
    title:'Erode Textile & Temple Tour',
    desc:"Turmeric City and Textile Hub — Bhavani Sangameshwarar Temple at the Kaveri–Bhavani confluence, Kodumudi Murugan Temple.",
    includes:['Bhavani Sangameshwarar Temple','Kodumudi Murugan Temple','Erode Textile Market','Kaveri River Sangam','Gobichettipalayam Sathyamangalam','Periyar Statue'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Kaveri–Bhavani sacred confluence',
    img:'/images/destinations/erode.jpg' },

  { id:77, state:'Tamil Nadu', cat:'Beaches & Coastal', dest:'Chennai', type:'Heritage', icon:'compass', tag:'New',
    title:'Chennai Heritage & Marina Tour',
    desc:"Tamil Nadu's capital — the world's second longest beach Marina, Kapaleeshwarar Temple, Fort St. George and vibrant food culture.",
    includes:['Marina Beach','Kapaleeshwarar Temple','Fort St. George Museum','San Thome Basilica','Valluvar Kottam','Guindy National Park'],
    duration:'Full Day / 2 Days', vehicle:'Any Vehicle', highlight:"World's 2nd longest beach",
    img:'/images/destinations/chennai.jpg' },

  { id:40, state:'Tamil Nadu', cat:'Other Destinations', dest:'Coimbatore', type:'Spiritual', icon:'temple',
    title:'Coimbatore Isha Yoga Tour',
    desc:"Isha Yoga Centre, Vellingiri Hills trek, Adiyogi Statue and the vibrant textile city.",
    includes:['Isha Yoga Centre','Adiyogi Shiva Statue','Vellingiri Hills (Dhyanalinga)','Marudamalai Murugan Temple','VOC Park','Kovai Kutralam Falls'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'108-ft Adiyogi Shiva statue',
    img:'/images/destinations/coimbatore.jpg' },

  /* ══════════════════════════════
     KERALA — HILL STATIONS
     ══════════════════════════════ */
  { id:41, state:'Kerala', cat:'Hill Stations', dest:'Munnar', type:'Honeymoon', icon:'heart', tag:'New',
    title:'Munnar Honeymoon Package',
    desc:"Misty tea valleys, waterfalls and the most romantic hill views in South India — Munnar is magical for newlyweds.",
    includes:['Mattupetty Dam Boating','Eravikulam National Park','Tea Museum','Top Station','Echo Point','Attukal Waterfalls'],
    duration:'2–3 Days', vehicle:'4-Seater Car', highlight:'Nilgiri Tahr spotting',
    img:'/images/destinations/munnar.jpg' },

  { id:42, state:'Kerala', cat:'Hill Stations', dest:'Munnar', type:'Family', icon:'users',
    title:'Munnar Family Hill Tour',
    desc:"Endless tea estates, elephant encounters and cool mountain air — perfect Kerala family escape.",
    includes:['Tea Plantation Walk','Mattupetty Dam','Kundala Lake','Eravikulam Park','Chinnar Wildlife Sanctuary','Pampadum Shola'],
    duration:'2 Days', vehicle:'7-Seater SUV', highlight:'Tea estate walking tour',
    img:'/images/destinations/munnar.jpg' },

  { id:43, state:'Kerala', cat:'Hill Stations', dest:'Wayanad', type:'Nature', icon:'leaf',
    title:'Wayanad Jungle & Heritage Tour',
    desc:"Edakkal Caves, Banasura Sagar Dam, Chembra Peak and tribal villages in the lush Wayanad forests.",
    includes:['Edakkal Caves','Banasura Sagar Dam','Soochipara Falls','Chembra Peak Trek','Pookode Lake','Muthanga Wildlife Sanctuary'],
    duration:'2 Days', vehicle:'4 or 7 Seater', highlight:'4,000-year-old cave paintings',
    img:'/images/destinations/wayanad.jpg' },

  { id:44, state:'Kerala', cat:'Hill Stations', dest:'Vagamon', type:'Honeymoon', icon:'heart',
    title:'Vagamon Meadows Honeymoon',
    desc:"The Meadows of Kerala — rolling green hills, pine forests and strawberry farms. Perfect hidden romantic getaway.",
    includes:['Vagamon Meadows','Kurisumala Ashram','Pine Forest','Thangalpara Viewpoint','Strawberry Farm','Paragliding Spot'],
    duration:'2 Days', vehicle:'4-Seater Car', highlight:'Hidden romantic hill retreat',
    img:'/images/destinations/vagamon.jpg' },

  { id:45, state:'Kerala', cat:'Hill Stations', dest:'Ponmudi', type:'Nature', icon:'compass',
    title:'Ponmudi Hills & Valley Tour',
    desc:"Kerala's mini-Ooty near Thiruvananthapuram — 22 hairpin bends, Peppara Dam and the Golden Valley.",
    includes:['Ponmudi Peak','Golden Valley View','22 Hairpin Drive','Peppara Wildlife Sanctuary','Kallar River','Deer Spotting'],
    duration:'Full Day', vehicle:'4 or 7 Seater', highlight:'22 hairpin bends drive',
    img:'/images/destinations/ponmudi.jpg' },

  { id:46, state:'Kerala', cat:'Hill Stations', dest:'Idukki', type:'Nature', icon:'compass',
    title:'Idukki Arch Dam & Jungle Tour',
    desc:"Asia's first arch dam set in a stunning gorge — Idukki Wildlife Sanctuary, Thattekad Bird Sanctuary.",
    includes:['Idukki Arch Dam','Idukki Wildlife Sanctuary','Malankara Reservoir','Ramakkalmedu Wind Farm','Cheruthoni Dam','Thattekad Bird Sanctuary'],
    duration:'Full Day', vehicle:'4 or 7 Seater', highlight:'Asia\'s first arch dam',
    img:'/images/destinations/idukki.jpg' },

  { id:47, state:'Kerala', cat:'Hill Stations', dest:'Nelliyampathy', type:'Nature', icon:'compass',
    title:'Nelliyampathy Coffee Hills Tour',
    desc:"Kerala's secret hill station — coffee and tea estates, Kaikatty Valley and magnificent sunsets over the Palakkad Gap.",
    includes:['Nelliyampathy Peak','Coffee Estate Walk','Seethargundu Viewpoint','Pothundi Dam','Nelliampathy Village','Malampuzha Drive'],
    duration:'Full Day', vehicle:'4 or 7 Seater', highlight:'Unspoiled coffee hill estate',
    img:'/images/destinations/nelliyampathy.jpg' },

  /* ══════════════════════════════
     KERALA — BACKWATERS
     ══════════════════════════════ */
  { id:48, state:'Kerala', cat:'Backwaters', dest:'Alappuzha', type:'Houseboat', icon:'compass', tag:'Popular',
    title:'Alleppey Houseboat Cruise',
    desc:"Float through the Venice of the East — overnight houseboat through Vembanad Lake and rice paddies.",
    includes:['Houseboat Overnight Stay','Vembanad Lake Cruise','Alleppey Beach','Marari Beach','Coir Village','Nehru Trophy Boat Race Site'],
    duration:'2 Days / 1 Night', vehicle:'Transfer provided', highlight:'Overnight in backwater houseboat',
    img:'/images/destinations/alappuzha.jpg' },

  { id:49, state:'Kerala', cat:'Backwaters', dest:'Kumarakom', type:'Nature', icon:'compass',
    title:'Kumarakom Bird Sanctuary Tour',
    desc:"Kumarakom Bird Sanctuary on the banks of Vembanad Lake — the perfect Kerala backwater and bird watching combo.",
    includes:['Kumarakom Bird Sanctuary','Vembanad Lake Cruise','Aruvikkuzhi Waterfall','Baker\'s Bungalow','Toddy Tapping Experience','Village Canoe Ride'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'500+ species bird sanctuary',
    img:'/images/destinations/kumarakom.jpg' },

  { id:50, state:'Kerala', cat:'Backwaters', dest:'Kollam', type:'Backwater', icon:'compass',
    title:'Kollam Backwater & Beach Tour',
    desc:"Gateway to Kerala backwaters — Ashtamudi Lake houseboat, Cashew Capital and pristine Kollam beach.",
    includes:['Ashtamudi Lake Cruise','Kollam Beach','Cashew Factory Visit','Thangasserry Fort','Jatayu Earth\'s Centre','Palaruvi Falls'],
    duration:'Full Day / Overnight', vehicle:'Any Vehicle', highlight:'Ashtamudi 8-armed lake cruise',
    img:'/images/destinations/kollam.jpg' },

  { id:51, state:'Kerala', cat:'Backwaters', dest:'Kuttanad', type:'Nature', icon:'leaf',
    title:'Kuttanad Below Sea Level Tour',
    desc:"The Rice Bowl of Kerala — paddy fields below sea level, Chinese fishing nets and traditional Kerala village life.",
    includes:['Kuttanad Paddy Fields','Chinese Fishing Nets','Champakulam Church','Thazhathangady Heritage Walk','Backwater Village Canoe','Nehru Trophy Venue'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Farming below sea level — unique!',
    img:'/images/destinations/kuttanad.jpg' },

  /* ══════════════════════════════
     KERALA — BEACHES
     ══════════════════════════════ */
  { id:52, state:'Kerala', cat:'Beaches & Coastal', dest:'Kovalam', type:'Beach', icon:'compass',
    title:'Kovalam Beach Paradise Tour',
    desc:"Kerala's most famous beach — three crescent beaches, lighthouse sunset view and Ayurvedic massage.",
    includes:['Lighthouse Beach','Hawa Beach','Samudra Beach','Vizhinjam Mosque','Padmanabhaswamy Temple','Attukal Bhagavathy Temple'],
    duration:'2 Days', vehicle:'4 or 7 Seater', highlight:'Lighthouse sunset views',
    img:'/images/destinations/kovalam.jpg' },

  { id:53, state:'Kerala', cat:'Beaches & Coastal', dest:'Varkala', type:'Beach', icon:'compass',
    title:'Varkala Cliff Beach Tour',
    desc:"A beach town with a difference — dramatic red cliffs overlooking the Arabian Sea, Janardhana Swami Temple.",
    includes:['Varkala North Beach','Varkala Cliff Walk','Janardhana Swami Temple','Papanasam Beach','Anjengo Fort','Azhimala Shiva Temple'],
    duration:'Full Day / 2 Days', vehicle:'4 or 7 Seater', highlight:'Cliff-top Arabian Sea views',
    img:'/images/destinations/varkala.jpg' },

  { id:54, state:'Kerala', cat:'Beaches & Coastal', dest:'Bekal', type:'Heritage', icon:'compass',
    title:'Bekal Fort & Beach Tour',
    desc:"The largest fort in Kerala on a dramatic rocky headland overlooking the Arabian Sea — Bekal Fort, Kappil Beach.",
    includes:['Bekal Fort','Kappil Beach','Bekal Hole Aqua Tourism','Nityananda Ashram','Chandragiri Fort','Kasaragod Town'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Largest fort in Kerala',
    img:'/images/destinations/bekal.jpg' },

  { id:55, state:'Kerala', cat:'Beaches & Coastal', dest:'Marari Beach', type:'Beach', icon:'compass',
    title:'Marari Beach Village Tour',
    desc:"A hidden paradise — a quiet fishing village beach perfect for couples and families seeking a peaceful Kerala escape.",
    includes:['Marari Beach','Coir Village Visit','Fisher Village Walk','Alappuzha Day Trip','Backwater Village Canoe','Coconut Farm Tour'],
    duration:'Full Day / 2 Days', vehicle:'4 or 7 Seater', highlight:'Secluded unspoiled beach',
    img:'/images/destinations/marari-beach.jpg' },

  /* ══════════════════════════════
     KERALA — WILDLIFE / NATURE
     ══════════════════════════════ */
  { id:56, state:'Kerala', cat:'Nature & Wildlife', dest:'Thekkady', type:'Wildlife', icon:'compass',
    title:'Thekkady Periyar Tiger Reserve',
    desc:"Periyar Lake boat safari — spot wild elephants, sambar deer and rare birds in their natural habitat.",
    includes:['Periyar Lake Boat Safari','Kumily Spice Market','Elephant Junction','Bamboo Rafting','Nature Walk','Cardamom Estate Visit'],
    duration:'Full Day / 2 Days', vehicle:'4 or 7 Seater', highlight:'Lake safari — wild elephant herds',
    img:'/images/destinations/thekkady.jpg' },

  { id:57, state:'Kerala', cat:'Nature & Wildlife', dest:'Eravikulam National Park', type:'Wildlife', icon:'compass',
    title:'Eravikulam Nilgiri Tahr Tour',
    desc:"Home of the endangered Nilgiri Tahr — the only place in the world you can see them up close in the wild.",
    includes:['Eravikulam NP','Nilgiri Tahr Safari','Rajamala Peak','Anamudi Base','Munnar Town','Tea Museum'],
    duration:'Full Day', vehicle:'4 or 7 Seater', highlight:'Endangered Nilgiri Tahr up close',
    img:'/images/destinations/eravikulam-national-park.jpg' },

  { id:58, state:'Kerala', cat:'Nature & Wildlife', dest:'Athirappilly Falls', type:'Nature', icon:'compass',
    title:'Athirappilly Waterfalls Tour',
    desc:"The Niagara of India in Kerala — the largest waterfall in Kerala at 80 ft, surrounded by dense rainforest.",
    includes:['Athirappilly Falls','Vazhachal Falls','Charpa Falls','Thumboormuzhi Dam','Sholayar Dam','Chalakudy River Rafting'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Kerala\'s largest waterfall',
    img:'/images/destinations/athirappilly-falls.jpg' },

  { id:59, state:'Kerala', cat:'Nature & Wildlife', dest:'Silent Valley National Park', type:'Wildlife', icon:'compass',
    title:'Silent Valley National Park Trek',
    desc:"One of the last undisturbed tropical rainforests in India — Lion-tailed Macaque, rare flora and pristine streams.",
    includes:['Silent Valley Core Zone','Sairandhri Viewpoint','Kunthipuzha River','Lion-tailed Macaque Spotting','Mud Tribes Village','Palakkad Gap View'],
    duration:'Full Day', vehicle:'4 or 7 Seater', highlight:'Last untouched tropical rainforest',
    img:'/images/destinations/silent-valley-national-park.jpg' },

  { id:60, state:'Kerala', cat:'Nature & Wildlife', dest:'Meesapulimala', type:'Adventure', icon:'mountain',
    title:'Meesapulimala Trek (2nd Highest)',
    desc:"The 2nd highest peak in Western Ghats — a challenging trek through shola grasslands with stunning 360° views.",
    includes:['Meesapulimala Summit Trek','Rhino Valley','Top Station','Munnar Town','Tea Estate Trail','Camp Fire (Night)'],
    duration:'2 Days / 1 Night', vehicle:'4 or 7 Seater', highlight:'2nd highest peak in Western Ghats',
    img:'/images/destinations/meesapulimala.jpg' },

  /* ══════════════════════════════
     KERALA — CITIES / CULTURAL
     ══════════════════════════════ */
  { id:61, state:'Kerala', cat:'Cities & Culture', dest:'Kochi', type:'Heritage', icon:'compass',
    title:'Kochi Fort & Backwater Tour',
    desc:"Queen of the Arabian Sea — Chinese fishing nets, Fort Kochi heritage walk, Mattancherry spice market and Jewish Synagogue.",
    includes:['Fort Kochi Walk','Chinese Fishing Nets','Jewish Synagogue','Mattancherry Palace','Spice Market','Marine Drive'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Chinese fishing nets at sunset',
    img:'/images/destinations/kochi.jpg' },

  { id:62, state:'Kerala', cat:'Cities & Culture', dest:'Thrissur', type:'Cultural', icon:'compass',
    title:'Thrissur Cultural & Vadakkumnathan Tour',
    desc:"Cultural Capital of Kerala — Vadakkumnathan Temple, famous Thrissur Pooram venue, Athirapally Falls combine.",
    includes:['Vadakkumnathan Temple','Thrissur Pooram Grounds','Kerala Sangeetha Nataka Academy','Shakthan Thampuran Palace','Peechi Dam','Athirappilly Falls'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Cultural capital of Kerala',
    img:'/images/destinations/thrissur.jpg' },

  { id:63, state:'Kerala', cat:'Cities & Culture', dest:'Thiruvananthapuram', type:'Cultural', icon:'temple',
    title:'Trivandrum Heritage & Kovalam Tour',
    desc:"Kerala's capital — Padmanabhaswamy Temple, Napier Museum, Zoological Garden and Kovalam Beach.",
    includes:['Padmanabhaswamy Temple','Napier Museum','Zoological Garden','Kuthiramalika Palace','Kovalam Beach','Veli Tourist Village'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Padmanabhaswamy — richest temple',
    img:'/images/destinations/thiruvananthapuram.jpg' },

  { id:78, state:'Kerala', cat:'Cities & Culture', dest:'Kozhikode', type:'Heritage', icon:'compass',
    title:'Kozhikode Calicut Heritage Tour',
    desc:"The City of Spices — where Vasco da Gama landed, famous Kozhikode Halwa, Beypore boat-building yards and Mananchira Square.",
    includes:['Mananchira Square','Kozhikode Beach','Beypore Port & Boat Yard','Sweet Street Halwa Tasting','Kuttichira Heritage Mosque','Pazhassi Raja Museum'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:"Vasco da Gama's landing city",
    img:'/images/destinations/kozhikode.jpg' },

  { id:79, state:'Kerala', cat:'Cities & Culture', dest:'Palakkad', type:'Heritage', icon:'compass',
    title:'Palakkad Fort & Gap Tour',
    desc:"Gateway to Kerala — the magnificent Tipu Sultan Fort, Malampuzha Dam and the famous Palakkad Gap in the Western Ghats.",
    includes:['Palakkad Fort (Tipu Sultan)','Malampuzha Dam & Garden','Palakkad Gap Viewpoint','Silent Valley Entry Point','Parambikulam Dam','Dhoni Waterfalls'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:"Tipu Sultan's 18th century fort",
    img:'/images/destinations/palakkad.jpg' },

  /* ══════════════════════════════
     KERALA — OTHER DESTINATIONS
     ══════════════════════════════ */
  { id:64, state:'Kerala', cat:'Other Destinations', dest:'Guruvayur', type:'Pilgrimage', icon:'temple',
    title:'Guruvayur Sri Krishna Temple Tour',
    desc:"The Dwarka of the South — Guruvayur Sri Krishna Temple, Punnathur Kotta elephant sanctuary.",
    includes:['Guruvayur Sri Krishna Temple','Punnathur Kotta Elephant Sanctuary','Chavakad Beach','Thiruvambadi Krishna Temple','Mammiyoor Shiva Temple','Thrissur Combine'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'60+ captive elephants sanctuary',
    img:'/images/destinations/guruvayur.jpg' },

  { id:65, state:'Kerala', cat:'Other Destinations', dest:'Poovar', type:'Nature', icon:'compass',
    title:'Poovar Island & Estuary Tour',
    desc:"Where river, sea and backwaters meet — golden sand bar island, floating cottages and breathtaking sunsets.",
    includes:['Poovar Golden Sand Bar','Neyyar Dam Boat Safari','Crocodile Farm','Lighthouse Beach','Estuary Boat Ride','Kalaripayattu Show'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'River meets sea — floating resort',
    img:'/images/destinations/poovar.jpg' },

  { id:66, state:'Kerala', cat:'Other Destinations', dest:'Malampuzha', type:'Nature', icon:'leaf',
    title:'Malampuzha Dam & Fantasy Park',
    desc:"Palakkad\'s gem — Malampuzha Dam garden, ropeway, Fantasy Park and the famous rock garden.",
    includes:['Malampuzha Dam','Rock Garden','Ropeway Ride','Fantasy Park','Yakshi Sculpture','Palakkad Fort'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Fantasy Park ropeway over dam',
    img:'/images/destinations/malampuzha.jpg' },

  { id:67, state:'Kerala', cat:'Other Destinations', dest:'Thenmala', type:'Eco', icon:'leaf',
    title:'Thenmala Eco Tourism Tour',
    desc:"India's first planned eco-tourism destination — hanging bridge, deer park, sculpture garden and adventure activities.",
    includes:['Hanging Bridge','Deer Rehabilitation Centre','Shenduruney Wildlife Sanctuary','Kallada River Rafting','Butterfly Garden','Sculpture Garden'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'India\'s first eco-tourism site',
    img:'/images/destinations/thenmala.jpg' },

  { id:68, state:'Kerala', cat:'Other Destinations', dest:'Kappad Beach', type:'Heritage', icon:'compass',
    title:'Kappad Vasco da Gama Beach Tour',
    desc:"Where Vasco da Gama first landed in India in 1498 — historical Kappad Beach, Koyilandy and Kozhikode.",
    includes:['Kappad Beach & Memorial','Kozhikode Beachfront','Mananchira Square','Sweet Street Halwa Shops','Koyilandy Fishing Harbour','Beypore Port'],
    duration:'Full Day', vehicle:'Any Vehicle', highlight:'Where Vasco da Gama landed 1498',
    img:'/images/destinations/kappad-beach.jpg' },

  /* ══════════════════════════════
     SABARIMALA (PILGRIMAGE)
     ══════════════════════════════ */
  { id:69, state:'Kerala', cat:'Pilgrimage', dest:'Sabarimala', type:'Pilgrimage', icon:'temple', tag:'Pilgrimage Special',
    title:'Sabarimala Ayyappa Pilgrimage',
    desc:"Blessed journey to Lord Ayyappa — comfortable transport to Pamba base camp and back.",
    includes:['Erumeli Church & Mosque Stop','Pamba River Holy Bath','Sabarimala Sannidhanam','Malikappuram Devi Shrine','Neelimala Viewpoint','Return Transfer'],
    duration:'2–3 Days', vehicle:'7 or 12 Seater', highlight:'Season & non-season available',
    img:'/images/destinations/sabarimala.jpg' },

  /* ══════════════════════════════
     MULTI-DESTINATION COMBO PACKS
     ══════════════════════════════ */
  { id:70, state:'Combo', cat:'Multi-Destination', dest:'TN + Kerala Combo', type:'Grand Tour', icon:'compass', tag:'Best Value',
    title:'Ultimate South India Grand Tour',
    desc:"The best of Tamil Nadu + Kerala in one epic multi-day journey — temples, hills, backwaters, beaches and wildlife.",
    includes:['Kodaikanal Hills','Munnar Tea Estates','Alleppey Backwaters','Rameswaram Temple','Kanyakumari Sunrise','Periyar Wildlife'],
    duration:'7–10 Days', vehicle:'Any Vehicle', highlight:'7+ destinations — 1 trip',
    img:'/images/destinations/tn-kerala-combo.jpg' },

  { id:71, state:'Combo', cat:'Multi-Destination', dest:'Temple Circuit', type:'Pilgrimage', icon:'temple',
    title:'South India Temple Circuit',
    desc:"The grand Dravidian temple tour — Meenakshi Madurai, Ramanathaswamy Rameswaram, Nataraja Chidambaram and more.",
    includes:['Meenakshi Temple Madurai','Ramanathaswamy Rameswaram','Nataraja Temple Chidambaram','Brihadeeswarar Thanjavur','Ranganathaswamy Srirangam','Tirumala Tirupati'],
    duration:'5–7 Days', vehicle:'Any Vehicle', highlight:'6 major Dravidian temples',
    img:'/images/destinations/temple-circuit.jpg' },

  { id:72, state:'Combo', cat:'Multi-Destination', dest:'Honeymoon Grand', type:'Honeymoon', icon:'heart',
    title:'Kerala + Kodaikanal Honeymoon',
    desc:"The ultimate South India honeymoon — misty Munnar hills, Alleppey houseboat, Varkala cliff beach and Kodaikanal sunsets.",
    includes:['Kodaikanal 2 Days','Munnar Tea Estate Stay','Alleppey Houseboat Night','Varkala Cliff Beach','Kovalam Sunset','Kanyakumari Sunrise'],
    duration:'8–10 Days', vehicle:'4-Seater Car', highlight:'The perfect South India honeymoon',
    img:'/images/destinations/honeymoon-grand.jpg' },

  /* ══════════════════════════════
     STATION PICKUP / TRANSFERS
     ══════════════════════════════ */
  { id:73, state:'Transfer', cat:'Pickup & Drop', dest:'Kodai Road', type:'Transfer', icon:'compass',
    title:'Kodai Road Station Pickup',
    desc:"Arriving by train? We'll pick you up from Kodai Road Railway Station and take you comfortably to any destination.",
    includes:['Station Pickup on Time','Door-to-Door Drop','AC Vehicle','Luggage Help','Any Arrival Time','No Hidden Charges'],
    duration:'1.5–2 hrs to Kodaikanal', vehicle:'Any Vehicle', highlight:'24/7 — any train timing',
    img:'/images/destinations/kodai-road.jpg' },

  { id:74, state:'Transfer', cat:'Pickup & Drop', dest:'Madurai Airport', type:'Transfer', icon:'compass',
    title:'Madurai Airport Transfer',
    desc:"Comfortable AC cab from Madurai Airport to Kodaikanal, Rameswaram or any destination.",
    includes:['Flight Tracking','Airport Meet & Greet','AC Vehicle','Hotel Drop','Luggage Assistance','Any Time'],
    duration:'2.5–3 hrs', vehicle:'Any Vehicle', highlight:'Flight tracking — never late',
    img:'/images/destinations/madurai-airport.jpg' },
];

/* ──────────────────────────────────────
   FILTER CONFIGURATION
   ────────────────────────────────────── */
const STATES = ['All States', 'Tamil Nadu', 'Kerala', 'Combo', 'Transfer'];

const TN_CATS  = ['Hill Stations','Temple & Spiritual','Heritage & Culture','Beaches & Coastal','Nature & Wildlife','Other Destinations'];
const KL_CATS  = ['Hill Stations','Backwaters','Beaches & Coastal','Nature & Wildlife','Cities & Culture','Pilgrimage','Other Destinations'];
const COMBOS   = ['Multi-Destination','Pickup & Drop'];
const TOUR_TYPES = ['All Types','Honeymoon','Family','Group','Pilgrimage','Sightseeing','Nature','Heritage','Wildlife','Adventure','Beach','Houseboat','Transfer','Grand Tour'];

export default function Tours() {
  const location = useLocation();
  const [stateFilter, setStateFilter] = useState('All States');
  const [catFilter,   setCatFilter]   = useState('');
  const [typeFilter,  setTypeFilter]  = useState('All Types');
  const [destFilter,  setDestFilter]  = useState('');
  const [search,      setSearch]      = useState('');
  const [expanded,    setExpanded]    = useState(null);
  const [view,        setView]        = useState('grid'); // 'grid' | 'list'

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const type = params.get('type');
    const category = params.get('category');
    const destination = params.get('destination');
    setTypeFilter(TOUR_TYPES.includes(type) ? type : 'All Types');
    setCatFilter(ALL_PACKAGES.some(p => p.cat === category) ? category : '');
    setDestFilter(ALL_PACKAGES.some(p => p.dest === destination) ? destination : '');
    setStateFilter('All States');
    setSearch(params.get('search') || '');
  }, [location.search]);

  // Dynamic categories based on state
  const activeCats = useMemo(() => {
    if (stateFilter === 'Tamil Nadu') return TN_CATS;
    if (stateFilter === 'Kerala')     return KL_CATS;
    if (stateFilter === 'Combo' || stateFilter === 'Transfer') return COMBOS;
    return [...new Set([...TN_CATS, ...KL_CATS, ...COMBOS])];
  }, [stateFilter]);

  // Filtered packages (full - used for count)
  const filtered = useMemo(() => ALL_PACKAGES.filter(p => {
    if (stateFilter !== 'All States' && p.state !== stateFilter) return false;
    if (catFilter   && p.cat  !== catFilter)   return false;
    if (typeFilter  !== 'All Types' && p.type !== typeFilter) return false;
    if (destFilter  && p.dest !== destFilter)  return false;
    if (search) {
      const q = search.trim().toLowerCase();
      return p.title.toLowerCase().includes(q) ||
             p.dest.toLowerCase().includes(q)  ||
             p.desc.toLowerCase().includes(q)  ||
             p.cat.toLowerCase().includes(q) ||
             p.includes.join(' ').toLowerCase().includes(q);
    }
    return true;
  }), [stateFilter, catFilter, typeFilter, destFilter, search]);

  // Packages matching only State + Category (for Type and Destination options)
  const catMatched = useMemo(() => ALL_PACKAGES.filter(p => {
    if (stateFilter !== 'All States' && p.state !== stateFilter) return false;
    if (catFilter && p.cat !== catFilter) return false;
    return true;
  }), [stateFilter, catFilter]);

  // Available types for current state+category combo
  const availableTypes = useMemo(() => {
    const types = [...new Set(catMatched.map(p => p.type))];
    return TOUR_TYPES.filter(t => t === 'All Types' || types.includes(t));
  }, [catMatched]);

  const availableDests = useMemo(() => [...new Set(catMatched.map(p => p.dest))].sort((a,b) => a.localeCompare(b)), [catMatched]);
  const featuredDestinations = useMemo(() => {
    const favourites = [destFilter, 'Kodaikanal', 'Munnar', 'Ooty', 'Madurai', 'Rameswaram', ...availableDests];
    return [...new Set(favourites)].filter(d => availableDests.includes(d)).slice(0,5).map(name => {
      const matches = catMatched.filter(p => p.dest === name);
      return { name, img: matches[0].img, count: matches.length };
    });
  }, [availableDests, catMatched, destFilter]);

  // Auto-clear invalid selections when category changes
  const handleCatChange = (cat) => {
    setCatFilter(cat);
    setTypeFilter('All Types');
    setDestFilter('');
  };

  const resetFilters = () => {
    setStateFilter('All States'); setCatFilter('');
    setTypeFilter('All Types');   setDestFilter(''); setSearch('');
  };

  const hasFilter = stateFilter !== 'All States' || catFilter || typeFilter !== 'All Types' || destFilter || search;

  return (
    <div className="tours-page page-enter">

      {/* ── HERO ── */}
      <div className="tours-hero">
        <div className="tours-hero__bg" style={{ backgroundImage: "url('/images/destinations/kodaikanal.jpg')" }} />
        <div className="tours-hero__overlay" />
        <div className="container tours-hero__content">
          <p className="eyebrow">Maggi Cabs — Since 2003</p>
          <h1 className="display-title light">All Tour Packages</h1>
          <div className="amber-line" />
          <p>79 packages across 75 destinations in Tamil Nadu & Kerala. Call +91 9445879508 anytime.</p>
          <div className="tours-hero-stats">
            <span> 75 Destinations</span>
            <span> 79 Packages</span>
            <span> 4 Vehicle Types</span>
            <span> 24/7 Booking</span>
          </div>
        </div>
      </div>

      {/* ── STATE SELECTOR ── */}
      <div className="state-bar">
        <div className="container state-bar__inner">
          {STATES.map(s => (
            <button key={s}
              className={`state-btn ${stateFilter === s ? 'active' : ''}`}
              onClick={() => { setStateFilter(s); setCatFilter(''); setTypeFilter('All Types'); setDestFilter(''); }}>
              {s === 'Tamil Nadu' ? ' Tamil Nadu' :
               s === 'Kerala'    ? ' Kerala'     :
               s === 'Combo'     ? ' Combos'     :
               s === 'Transfer'  ? ' Transfers'  : ' All States'}
            </button>
          ))}
        </div>
      </div>

      {/* ── MAIN CONTENT ── */}
      <section className="section-pad">
        <div className="container">

          {/* ── FILTER PANEL ── */}
          <div className="destination-finder" aria-labelledby="finder-title">
            <div className="finder-heading">
              <div><p className="eyebrow">Your next chapter starts here</p><h2 id="finder-title">Where shall we take you?</h2></div>
              <span className="finder-note"><Icon name="compass" size={18} />Local routes. Memorable journeys.</span>
            </div>
            <div className="finder-search">
              <Icon name="pin" size={25} />
              <div><label htmlFor="destination-search">Find your next escape</label>
                <input id="destination-search" type="search" placeholder="Try Kodaikanal, a temple or a beach" value={search} onChange={e => setSearch(e.target.value)} />
              </div>
              {search && <button type="button" aria-label="Clear search" onClick={() => setSearch('')}>Clear</button>}
              <span className="finder-search__hint">Explore South India</span>
            </div>
            <div className="finder-controls">
              <label>Destination<select aria-label="Destination" value={destFilter} onChange={e => setDestFilter(e.target.value)}><option value="">Anywhere</option>{availableDests.map(d => <option key={d}>{d}</option>)}</select></label>
              <label>What do you love?<select aria-label="Category" value={catFilter} onChange={e => handleCatChange(e.target.value)}><option value="">All experiences</option>{activeCats.map(c => <option key={c}>{c}</option>)}</select></label>
              <label>Your travel style<select aria-label="Travel style" value={typeFilter} onChange={e => setTypeFilter(e.target.value)}>{availableTypes.map(t => <option key={t} value={t}>{t === 'All Types' ? 'Any travel style' : t}</option>)}</select></label>
              <button className="finder-reset" onClick={resetFilters} disabled={!hasFilter}>Reset filters</button>
            </div>
            <div className="finder-inspiration"><span>A little inspiration</span><span>Choose a place to explore</span></div>
            <div className="finder-destinations">
              {featuredDestinations.map(d => <button key={d.name} className={'finder-destination ' + (destFilter === d.name ? 'is-selected' : '')} aria-pressed={destFilter === d.name} onClick={() => { setDestFilter(destFilter === d.name ? '' : d.name); setTypeFilter('All Types'); setSearch(''); }}>
                <PlaceImage src={d.img} alt="" loading="lazy" />
                <span className="finder-destination__shade" />
                <span className="finder-destination__text"><strong>{d.name}</strong><small>{d.count} {d.count === 1 ? 'journey' : 'journeys'} to discover</small></span>
                <span className="finder-destination__arrow"><Icon name="arrow" size={17} /></span>
                {destFilter === d.name && <span className="finder-destination__selected">Selected</span>}
              </button>)}
            </div>
          </div>

          {/* Results bar */}
          <div className="results-bar">
            <div className="results-info" role="status" aria-live="polite">
              Showing <strong>{filtered.length}</strong> of {ALL_PACKAGES.length} packages
              {catFilter && <span className="results-tag">{catFilter}</span>}
              {destFilter && <span className="results-tag">{destFilter}</span>}
              {typeFilter !== 'All Types' && <span className="results-tag">{typeFilter}</span>}
            </div>
            <div className="results-actions">
              {hasFilter && (
                <button className="clear-all-btn" onClick={resetFilters}>✕ Clear All</button>
              )}
              <div className="view-toggle">
                <button aria-label="Grid view" aria-pressed={view === 'grid'} className={view === 'grid' ? 'active' : ''} onClick={() => setView('grid')}>
                  <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24"><path d="M3 3h7v7H3V3zm11 0h7v7h-7V3zM3 14h7v7H3v-7zm11 0h7v7h-7v-7z"/></svg>
                </button>
                <button aria-label="List view" aria-pressed={view === 'list'} className={view === 'list' ? 'active' : ''} onClick={() => setView('list')}>
                  <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24"><path d="M3 4h18v2H3V4zm0 7h18v2H3v-2zm0 7h18v2H3v-2z"/></svg>
                </button>
              </div>
            </div>
          </div>

          {/* ── PACKAGES ── */}
          {filtered.length === 0 ? (
            <div className="tours-empty">
              <span><Icon name="compass" /></span>
              <h3>No packages found</h3>
              <p>Try different filters or search terms</p>
              <button className="btn-green" onClick={resetFilters}>View All Packages</button>
            </div>
          ) : (
            <div className={`pkg-grid ${view === 'list' ? 'pkg-grid--list' : ''}`}>
              {filtered.map(pkg => (
                <div key={pkg.id} className={`pkg-card card ${view === 'list' ? 'pkg-card--list' : ''}`}>

                  <div className="pkg-card__img">
                    <PlaceImage src={pkg.img} alt={pkg.title} loading="lazy" />
                    <div className="pkg-img-overlay" />
                    <div className="pkg-img-badges">
                      <span className="pkg-state-badge">{pkg.state}</span>
                      <span className="pkg-region-badge">{pkg.cat}</span>
                    </div>
                    {pkg.tag && <span className="pkg-tag">{pkg.tag}</span>}
                  </div>

                  <div className="pkg-card__body">
                    <div className="pkg-card__head">
                      <span className="pkg-icon"><Icon name={pkg.icon} /></span>
                      <div>
                        <span className="pkg-dest-label"> {pkg.dest}</span>
                        <h3 className="pkg-title">{pkg.title}</h3>
                      </div>
                    </div>

                    <p className="pkg-desc">{pkg.desc}</p>

                    {/* Expandable highlights */}
                    <div className="pkg-includes">
                      <button className="pkg-includes__btn"
                        onClick={() => setExpanded(expanded === pkg.id ? null : pkg.id)}>
                        <span>✓ {pkg.includes.length} Highlights</span>
                        <span className="pkg-arrow">{expanded === pkg.id ? '▲' : '▼'}</span>
                      </button>
                      {expanded === pkg.id && (
                        <div className="pkg-tags-wrap">
                          {pkg.includes.map(item => (
                            <span key={item} className="pkg-tag-item">✓ {item}</span>
                          ))}
                        </div>
                      )}
                    </div>

                    <div className="pkg-meta">
                      <span> {pkg.duration}</span>
                      <span> {pkg.vehicle}</span>
                      <span className="pkg-highlight-badge">★ {pkg.highlight}</span>
                    </div>

                    <div className="pkg-actions">
                      <a href={`https://wa.me/${WA}?text=Hi%20Anbu%20Kumar!%20I%27m%20interested%20in%20${encodeURIComponent(pkg.title)}`}
                        target="_blank" rel="noreferrer" className="btn-primary"> Book Now</a>
                      <a href="tel:+919445879508" className="btn-green"> Call</a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Custom CTA */}
      <div className="tours-cta container">
        <div className="tours-cta__inner">
          <div>
            <h3> Need a Custom Multi-Day Tour?</h3>
            <p>Mix any Tamil Nadu + Kerala destinations — we plan the perfect itinerary for your group & budget!</p>
          </div>
          <a href={`https://wa.me/${WA}?text=Hi!%20I%20need%20a%20custom%20multi-destination%20tour%20package.`}
            target="_blank" rel="noreferrer" className="btn-primary"> WhatsApp for Custom Tour</a>
        </div>
      </div>
    </div>
  );
}